import { isFunc, isBoolean, isObj, isArray, isString } from '@/utils/is'
import {
  intersectionWith,
  isEqual,
  mergeWith,
  unionWith,
  cloneDeep as lodashCloneDeep
} from 'lodash-es'
import globalEnv from '@/configs'
// import { IdWorker } from './randomInt'
// const idWorker = new IdWorker(1n, 1n)
// import SnowflakeIdGen from 'snowflake-idgen'
// const idGen = new SnowflakeIdGen(1)
/**
 * @author：张胜
 * @desc：通用递归
 * */
export const recursion = (list: any[], fn: Fn, config = { children: 'children' }) => {
  const { children } = config
  const recursionFn = (arr = [], parent = null) => {
    let interruptFlag = false // 中断递归标志
    for (const item of arr) {
      interruptFlag = isFunc(fn) ? fn(item, parent) : false
      if (isBoolean(interruptFlag) && interruptFlag) {
        // 当函数返回布尔值且为true时,中断递归
        return true
      } else {
        interruptFlag = recursionFn(item[children] || [], item) || false
        if (isBoolean(interruptFlag) && interruptFlag) {
          // 当函数返回布尔值且为true时,中断递归
          return true
        }
      }
    }
  }
  recursionFn(list as any)
}

/**
 * @author：张胜
 * @desc：递归合并两个对象。
 * @param source The source object to merge from. 要合并的源对象。
 * @param target The target object to merge into. 目标对象，合并后结果存放于此。
 * @param mergeArrays How to merge arrays. Default is "replace".
 *        如何合并数组。默认为replace。
 *        - "union": Union the arrays. 对数组执行并集操作。[1,2] [1,2,3] => [1,2,3]
 *        - "intersection": Intersect the arrays. 对数组执行交集操作。[1] [2] => []   [1,2] [1] => [1]
 *        - "concat": Concatenate the arrays. 连接数组。[1] [1,2,3] => [1,1,2,3]
 *        - "replace": Replace the source array with the target array. 用目标数组替换源数组。[1] [2] => [2]
 * @returns The merged object. 合并后的对象。
 */
export function deepMerge<T extends object | null | undefined, U extends object | null | undefined>(
  source: T,
  target: U,
  mergeArrays: 'union' | 'intersection' | 'concat' | 'replace' = 'replace'
): T & U {
  if (!target) {
    return source as T & U
  }
  if (!source) {
    return target as T & U
  }
  return mergeWith({}, source, target, (sourceValue, targetValue) => {
    if (isArray(targetValue) && isArray(sourceValue)) {
      switch (mergeArrays) {
        case 'union':
          return unionWith(sourceValue, targetValue, isEqual)
        case 'intersection':
          return intersectionWith(sourceValue, targetValue, isEqual)
        case 'concat':
          return sourceValue.concat(targetValue)
        case 'replace':
          return targetValue
        default:
          throw new Error(`Unknown merge array strategy: ${mergeArrays as string}`)
      }
    }
    if (isObj(targetValue) && isObj(sourceValue)) {
      return deepMerge(sourceValue, targetValue, mergeArrays)
    }
    return undefined
  })
}

/**
 * @author：张胜
 * @desc；深拷贝
 * */
export const cloneDeep = (obj: any) => {
  return lodashCloneDeep(obj)
}

/**
 * @author：张胜
 * @desc：生成一个用不重复的ID
 */
export function GenNonDuplicateID(randomLength: number) {
  return Number(Math.random().toString().substr(3, randomLength) + Date.now())
    .toString(36)
    .toUpperCase()
}

// uuid
export function getUuid(len = 32, radix = 16) {
  const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('')
  const uuid = []
  let i
  radix = radix || chars.length
  if (len) {
    for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)]
  } else {
    let r
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-'
    uuid[14] = '4'
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | (Math.random() * 16)
        uuid[i] = chars[i === 19 ? (r & 0x3) | 0x8 : r]
      }
    }
  }
  return uuid.join('')
}

export function _randomInt(_n: number): number {
  // if (n <= 0) return -1 // 只能输入正整数哦
  // const limit = Math.pow(10, n)
  // const value = Math.floor(Math.random() * limit) // 用随机数向下取整，避免多一位
  // if (value < (limit / 10) && value !== 0) { // 取一位的时候就用不到这个函数啦，不过还是要把 0 这个小朋友放行的
  //   return _randomInt(n)
  // }
  // return value
  // return Number(idWorker.getUniqueId().toString())
  const numbers = '0123456789'
  let result = ''

  while (result.length < 6) {
    const randomIndex = Math.floor(Math.random() * numbers.length)
    const randomChar = numbers.charAt(randomIndex)
    result += randomChar.toString()
  }
  return Number(`${new Date().getTime()}${result}`)
}

/**
 * @author：张胜
 * @desc：阿拉伯数字转大写
 * */
// export const numToCapital = (num: number | string, type: boolean) => {
//   if (!num) return 0
//   const strNum = Number((num + '').replace(/[,，]*/g, '')) + '' // 记录字符
//   num = parseInt(String(Number(strNum))) // 转为整数，
//   let capitalAr = '零一二三四五六七八九十'
//   let unitAr = ['十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千']
//   if (type) {
//     capitalAr = '零壹贰叁肆伍陆柒捌玖拾'
//     unitAr = ['拾', '佰', '仟', '万', '拾', '佰', '仟', '亿', '拾', '佰', '仟'] // 单位
//   }
//   const resultAr: any = [] // 记录结果，后边json.in就可
//   const index = strNum.length - 1 // 记录位数
//   let idx = 0 // 记录单位
//   const percent = 10
//   const turnNum = (num: number, percent: number, index: number) => {
//     const unit = num / percent
//     const capital = capitalAr[Number(strNum[index])]
//     if (unit < 1) {
//       resultAr.push(capital)
//       // 出现11【一十一】这种情况
//       if (Number(strNum[index]) === 1 && (strNum.length === 2 || strNum.length === 6 || strNum.length === 10)) {
//         resultAr.pop()
//       }
//       return false // 结束递归
//     } else {
//       if (capital === '零') {
//         // 万和亿单位不删除
//         if (!['万', '亿'].includes(resultAr[resultAr.length - 1])) {
//           resultAr.pop()
//         }
//         // 前面有零在删掉一个零
//         if (resultAr[resultAr.length - 1] === '零') {
//           resultAr.pop()
//         }
//       }
//       resultAr.push(capital)
//       // 过滤存在【零万】【零亿】这种情况
//       if (['万', '亿'].includes(resultAr[resultAr.length - 2]) && capital === '零') {
//         resultAr.pop()
//       }
//       // 过滤【1亿万】这种情况
//       if (resultAr[0] === '万' && resultAr[1] === '亿') {
//         resultAr.shift()
//       }
//       // 末尾【零】删掉
//       if (resultAr[0] === '零') {
//         resultAr.pop()
//       }
//       resultAr.push(unitAr[idx++])
//       turnNum(num, percent * 10, --index)
//     }
//   }
//   turnNum(num, percent, index)
//   return resultAr.reverse().join('')
// }
export const numToCapital = (n: number) => {
  /** 数字金额大写转换(可以处理整数,小数,负数) */
  const fraction = ['角', '分']
  const digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
  const unit = [
    ['元', '万', '亿'],
    ['', '拾', '佰', '仟']
  ]
  const head = n < 0 ? '负' : ''
  n = Math.abs(n)

  let s = ''

  for (let i = 0; i < fraction.length; i++) {
    s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '')
  }
  s = s || '整'
  n = Math.floor(n)

  for (let i = 0; i < unit[0].length && n > 0; i++) {
    let p = ''
    for (let j = 0; j < unit[1].length && n > 0; j++) {
      p = digit[n % 10] + unit[1][j] + p
      n = Math.floor(n / 10)
    }
    s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s
  }
  return (
    head +
    s
      .replace(/(零.)*零元/, '元')
      .replace(/(零.)+/g, '零')
      .replace(/^整$/, '零元整')
  )
}
/**
 * @description: 百分比计算
 * @author:djsong
 * @date:2019/8/1
 * @param:a 被除数
 * @param:b 除数
 * @return:string
 */
export const percentage = (a: number, b: number) => {
  const value = a / b
  if (value === Infinity) return '0%'
  return isNaN(value) ? '0%' : (value * 100).toFixed(2) + '%'
}

export const getBasParams = (data: any = {}) => {
  const params: any = {}
  for (const i in data) {
    const val = data[i]
    params[i] = isString(val) ? val.trim() : val
  }
  return {
    ...params
  }
}
// 根据文件后缀判断是否是图片
export function isImageFile(filUrl: string) {
  const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', 'webp']
  const lowercaseFilename = filUrl.toLowerCase()

  for (const extension of imageExtensions) {
    if (lowercaseFilename.endsWith(extension)) {
      return true
    }
  }

  return false
}
/**
 * @desc:图片替换
 * @author:祁昌玲
 * @param:picturePath 图片地址
 * @return:completePicturePath
 */
export const picturePath = (picturePath: string) => {
  if (isString(picturePath) && picturePath.indexOf('http') !== -1) {
    return picturePath
  } else {
    return globalEnv.imgBaseUrl + picturePath
  }
}
/**
 * @desc:图片全路径
 * @author:祁昌玲
 * @param:imgPath 后端返回的图片地址
 * @return:completePicturePath
 */
export function userAvatar(imgPath: string) {
  return imgPath ? picturePath(imgPath) : require('@/assets/common/user_ico@2x.png')
}

// 根据路径获取文件名
export function getFileName(path: string) {
  const arr = path?.split('/') || []
  return arr[arr.length - 1]
}
/**
 * 将图片转成base64
 * 图片上传之后我们并不能直接获取到图片的分辨率，我们需要先将其转为base64的格式再去获取图片的分辨率，我们可以使用FileReader来先对文件进行转换
 * */
export function imgToBase64(file: any) {
  const reader = new FileReader()
  reader.readAsDataURL(file)
  return new Promise(resolve => {
    reader.onload = () => {
      resolve(reader.result)
    }
  })
}
/**
 * 获取图片的分辨率
 * */
export function getImgPx(img: string) {
  const image = new Image()
  image.src = img
  return new Promise(resolve => {
    image.onload = () => {
      const width = image.width
      const height = image.height
      resolve({ width, height })
    }
  })
}

/**
 * deepMergeReplace  比对更新 传了属性就更新（不管是undefined,null还是其他） 没有传就不更新
 * @param source
 * @param target
 */
export function deepMergeReplace(source: Recordable, target: Recordable): Recordable {
  const result = cloneDeep(source)
  for (const key in target) {
    if (isObj(target[key])) {
      result[key] = deepMergeReplace(source[key] || {}, target[key])
    } else {
      result[key] = target[key]
    }
  }
  return result
}

/**
 *
 * @function sleep
 * @description 异步延迟指定的毫秒数后执行
 * @param {number} ms - 指定延迟的毫秒数
 * @returns {Promise<void>} 在延迟结束后返回一个resolved的Promise
 */
export const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms))

/**
 * 获取文件后缀
 */
export function getFileExtension(fileName: string) {
  const match = fileName.match(/\.([^.]+)$/)
  return match && match.length > 1 ? match[1] : ''
}
/**
 *
 * @function differenceArray
 * @description 取两个数组对象的差集
 * @returns {Promise<void>} 在延迟结束后返回一个resolved的Promise
 */
export function differenceArray(arr1: Recordable, arr2: Recordable, key: string) {
  const set2 = new Set(arr2.map((item: Recordable) => item[key]))
  return arr1.filter((item: Recordable) => !set2.has(item[key]))
}

// 精确计算方法 避免精度错误
export const calcMethods = {
  // 加法
  addition(arg1: number, arg2: number) {
    let r1, r2
    try {
      r1 = arg1.toString().split('.')[1].length
    } catch (e) {
      r1 = 0
    }
    try {
      r2 = arg2.toString().split('.')[1].length
    } catch (e) {
      r2 = 0
    }
    const m = Math.pow(10, Math.max(r1, r2))
    return (arg1 * m + arg2 * m) / m
  },
  // 减法
  subtraction(arg1: number, arg2: number) {
    let r1, r2
    try {
      r1 = arg1.toString().split('.')[1].length
    } catch (e) {
      r1 = 0
    }
    try {
      r2 = arg2.toString().split('.')[1].length
    } catch (e) {
      r2 = 0
    }
    const m = Math.pow(10, Math.max(r1, r2))
    // 动态控制精度长度
    const n = r1 >= r2 ? r1 : r2
    return ((arg1 * m - arg2 * m) / m).toFixed(n)
  },
  // 乘法
  accMul(arg1: number, arg2: number) {
    if (!arg1) {
      arg1 = 0
    }
    if (!arg2) {
      arg2 = 0
    }
    let m = 0
    const s1 = arg1.toString()
    const s2 = arg2.toString()
    try {
      m += s1.split('.')[1].length
    } catch (e) {
      // console.log(e);
    }
    try {
      m += s2.split('.')[1].length
    } catch (e) {
      // console.log(e);
    }
    return (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) / Math.pow(10, m)
  },
  // 除法
  division(arg1: number, arg2: number) {
    let t1 = 0
    let t2 = 0

    try {
      t1 = arg1.toString().split('.')[1].length
    } catch (e) {
      // console.log(e);
    }
    try {
      t2 = arg2.toString().split('.')[1].length
    } catch (e) {
      // console.log(e);
    }
    const r1 = Number(arg1.toString().replace('.', ''))
    const r2 = Number(arg2.toString().replace('.', ''))
    return (r1 / r2) * Math.pow(10, t2 - t1)
  }
}

export function getHashParam(paramName: string) {
  const hash = window.location?.hash || ''
  const paramsStr = hash.split('?')?.[1] || ''
  const params = new URLSearchParams(paramsStr)
  return params.get(paramName) || ''
}
